import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import auth from "./Registrarse/firebase";
import "./MenuPrincipal.css";

export default function MenuPrincipal({ onIdiomaSelect }) {
  

  const idiomas = ["Español", "Português", "English", "Italiano"];
  const [busqueda, setBusqueda] = useState("");
  const [usuarioSesion, setUsuarioSesion] = useState(
    auth.currentUser
  );
  const navigate = useNavigate();

  useEffect(() =>
    onAuthStateChanged(auth, setUsuarioSesion),
  []);

  const nombreUsuario =
    usuarioSesion?.displayName?.trim() ||
    usuarioSesion?.email?.split("@")[0] ||
    "Usuario";

  const handleSubmit = (e) => {
    e.preventDefault();

    if (busqueda.trim() !== "") {
      navigate(`/buscar?query=${encodeURIComponent(busqueda)}`);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
          placeholder="Buscar cómic..."
          className="campo-busqueda"
        />
      </form>

      <nav>
        <ul className="menu">
          <li><Link to="/">Inicio</Link></li>
          <li><Link to="/tags" className="boton-menu">Tags</Link></li>
          <li><Link to="/autores" className="boton-menu">AUTOR</Link></li>
          <li><Link to="/subir" className="boton-menu">SUBIR</Link></li>

          <li className="dropdown">
            <button className="dropdown-btn">Lenguaje ▼</button>
            <ul className="dropdown-content">
              {idiomas.map((idioma) => (
<li
  key={idioma}
onClick={() =>
  onIdiomaSelect
    ? onIdiomaSelect(idioma)
    : navigate(`/buscar?idioma=${encodeURIComponent(idioma)}`)
}
>
  {idioma}
</li>              ))}
            </ul>
          </li>

          <li>
            <Link to="/busqueda-precisa" className="boton-preciso">
              Búsqueda precisa
            </Link>
          </li>

          {usuarioSesion ? (
            <li className="menu-user">
              <span
                className="menu-user-name"
                title={`Sesión iniciada como ${nombreUsuario}`}
              >
                <span className="menu-user-icon" aria-hidden="true">
                  👤
                </span>
                {nombreUsuario}
              </span>
            </li>
          ) : (
            <>
              <li>
                <Link to="/login">Iniciar sesión</Link>
              </li>
              <li>
                <Link to="/register">Registrarse</Link>
              </li>
            </>
          )}
        </ul>
      </nav>
    </>
  );
}
